import { httpPost, httpDownload } from '../../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL } from '../../../../constants/external-constants';
import { getLocalTimeZone, convertToFormatTimeZoneDate } from '../../../../utils/helpers.utils';


import {
     setDebitorHistoryLogsLoading
    , getDebitorHistoryLogs
    , setDebitorHistoryPageSize
    , resetDebitorHistory
    , setDebitorHistoryColSearchStr
} from '../../../../constants/model-reducers/external/recharge/debitor-catalogue-history.settings';


const defaultState = () => ({
    HistoryTable: DEFAULT_TABLE_RESULT_MODEL,
    IsLoadingTable: false
});

const initialState = defaultState();

export const debitorHistoryActions = {

    getDebitorHistoryLogs: (debitorId, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination, Headers } = state().debitorHistory.HistoryTable;
        var formData = {
            DebitorID: debitorId,
            PageIndex: pageIndex,
            PageSize: Pagination.PerPage,
            PageSizes: Pagination.PageSizes,
            Headers: Headers,
           
        };

        dispatch({
            type: setDebitorHistoryLogsLoading,
            isLoadingTable: true
        });

        var result = await httpPost('external/recharge/getDebitorHistoryLogs', formData);

        dispatch({
            type: getDebitorHistoryLogs,
            historyTable: result,
            isLoadingTable: false
        });
    },

    resizeDebitorHistoryLogs: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setDebitorHistoryPageSize,
            pageSize: parseInt(pageSize),
        });
    },

    setDebitorHistoryColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { HistoryTable } = state().debitorHistory;
        var historyTableHeaderUpd = {
            ...HistoryTable,
            "Headers": {
                ...HistoryTable.Headers,
                [key]: {

                    ...HistoryTable.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setDebitorHistoryColSearchStr,
            historyTable: historyTableHeaderUpd
        });
    },

    resetDebitorHistory: () => (dispatch, state) => {
        dispatch({
            type: resetDebitorHistory
        })
    },

    extractDebitorHistoryLogs: (debitorId) => async (dispatch, state) => {
        const { Headers } = state().debitorHistory.HistoryTable;
        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');
        const filename = `ATEM ${dealName} Debitor History – ${formattedTimeZoneDate}`;

        var formData = {
            DebitorID: debitorId,
            Headers: Headers,
            FileName: filename,
            TimeZone: getLocalTimeZone()
        };
        httpDownload('external/recharge/getExtractDebitorHistoryLogs', formData)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },
}

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case setDebitorHistoryLogsLoading:
            return {
                ...state,
                IsLoadingTable: action.isLoadingTable
            }
        case getDebitorHistoryLogs:
            return {
                ...state,
                HistoryTable: action.historyTable,
                IsLoadingTable: action.isLoadingTable
            }
        case setDebitorHistoryPageSize:
            return {
                ...state,
                HistoryTable: {
                    ...state.HistoryTable,
                    Pagination: {
                        ...state.HistoryTable.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setDebitorHistoryColSearchStr:
            return {
                ...state,
                HistoryTable: action.historyTable,
            }
        case resetDebitorHistory:
            return initialState;
        default:
            return state;
    }
}